var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeShown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9 4.32727C9.51011 4.32727 7.57273 6.26466 7.57273 8.65455C7.57273 11.0444 9.51011 12.9818 11.9 12.9818C14.2899 12.9818 16.2273 11.0444 16.2273 8.65455C16.2273 6.26466 14.2899 4.32727 11.9 4.32727Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.65455C0 8.65455 3.78636 0 11.9 0C20.0136 0 23.8 8.65455 23.8 8.65455C23.8 8.65455 20.0136 17.3091 11.9 17.3091C3.78636 17.3091 0 8.65455 0 8.65455ZM2.43475 8.65454C2.47947 8.57603 2.52749 8.49333 2.57881 8.40689C3.0069 7.6859 3.65077 6.72899 4.51061 5.7802C6.24515 3.86623 8.68259 2.16364 11.9 2.16364C15.1174 2.16364 17.5549 3.86623 19.2894 5.7802C20.1492 6.72899 20.7931 7.6859 21.2212 8.40689C21.2725 8.49333 21.3205 8.57603 21.3652 8.65454C21.3205 8.73306 21.2725 8.81577 21.2212 8.9022C20.7931 9.62319 20.1492 10.5801 19.2894 11.5289C17.5549 13.4429 15.1174 15.1455 11.9 15.1455C8.68259 15.1455 6.24515 13.4429 4.51061 11.5289C3.65077 10.5801 3.0069 9.62319 2.57881 8.9022C2.52749 8.81577 2.47947 8.73306 2.43475 8.65454Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeShown);
export default __webpack_public_path__ + "static/media/EyeShown.c73ed5e9520862fb4fc202f977e0b4a6.svg";
export { ForwardRef as ReactComponent };